import { useEffect, useRef } from 'react';
import { isElectron } from '../../EnvironmentFlags/EnvironmentFlags';
import { useFullReset } from '../../../context/Kiosk/kiosk';
import { UseRestartOnBackAfterSignature } from './RestartOnBackAfterSignature.types';

/**
 * Mobile-only hook for routes that come AFTER the electronic-signature screen.
 *
 * On mount (when not running in Electron) pushes a sentinel `window.history`
 * entry so that the next browser back-press fires `popstate` without leaving
 * the page. On `popstate`, calls `useFullReset(true, false)` to clear the
 * in-progress check-in and navigate to `/`. The `false` for `abandoned` keeps
 * the audit log clean — once a consumer has signed, the appointment is not
 * considered abandoned.
 */
export const useRestartOnBackAfterSignature: UseRestartOnBackAfterSignature = () => {
    const reset = useFullReset(true, false);
    const resetRef = useRef<VoidFunction>(reset);

    useEffect(() => {
        resetRef.current = reset;
    }, [reset]);

    useEffect(() => {
        if (!isElectron()) {
            window.history.pushState(null, '', window.location.href);

            const handlePopState: VoidFunction = () => {
                void resetRef.current();
            };

            window.addEventListener('popstate', handlePopState);

            return () => {
                window.removeEventListener('popstate', handlePopState);
            };
        }
        return;
    }, []);
};
